<!-- 头部栏 -->
<template>
  <div class="header">
    <div class="left">
      <!-- <img class="img" src="../../assets/logo.png" alt="" /> -->
      <div class="shrink" @click="shrinkClick()">
        <i v-if="!isCollapse" class="el-icon-s-fold" style="display: block"></i>
        <i v-else class="el-icon-s-unfold" style="display: block"></i>

        <span class="dhzx"></span>
      </div>
      
      <span class="groupName" style="margin-left: 10px">{{ groupName }}</span>
    </div>
    <div class="right">
      <!-- <span v-if="groupLogo" style="display: -webkit-box">
        <img
          class="img"
          :src="groupLogo"
          alt=""
          style="width: 102px; height: auto"
        />
      </span>
      <span
        class="title"
        style="
          display: -webkit-box;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: pre-line;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          max-width: 220px;
        "
        >{{ groupName }}
      </span>
      <span @click="webSkip">
        <img
          src="../../assets/new/heard_img1.png"
          alt=""
          style="width: 130px; height: auto"
        />
      </span> -->
      <!-- <span @click="webCopy" style="color: #7861ff !important">
        复制链接
        <img
          src="../../assets/new/heard_img2.png"
          alt=""
          style="
            vertical-align: middle;
            width: 20px;
            height: 20px;
            margin-top: -3px;
            margin-left: 3px;
          "
        />
      </span> -->

      <div class="bktxu">
        <div class="bktxu_h1" @click="bktxu">
          访问专属PC网站
        </div>
        <div class="bktxu_h2">
          {{ domain }}
        </div> 
      </div>
      
      <div class="xcxtc">
        <el-popover
          placement="bottom" 
          trigger="click"> 
          <div> 
            <QrCode4 
              v-if="codeUrl"
              :id="invite_code"
              :experienceId="'exp_' + invite_code" 
              :pictureId="'picture_' + invite_code"  
              :invite_code="invite_code"
              :codeUrl="codeUrl"
              :is_open_xcx="is_open_xcx"  
              @RechargeData="RechargeData"
            /> 
          </div>
          <el-button slot="reference" style="border: none;">访问刷题小程序</el-button>
        </el-popover> 
      </div>
 
      <span 
        class="rightCloss picItem"
        @click="tobExperienceCard"
        style="margin-right: 10px">
        下载APP
      </span>

      <span
        class="rightCloss picItem"
        @click="userFeedback"
        style="margin-right: 10px"
      > 
        通知中心
        <i v-if="un_read_total > 0" class="el-icon-more tzzx"></i>
      </span>

      <span
        class="rightCloss picItem"
        @click="operationManual"
        style="margin-right: 40px"
      >
        <!-- <img
          class="picA1"
          src="../../assets/new/czsc_a1.png"
          alt=""
          style="
            vertical-align: middle;
            width: 20px;
            height: 20px;
            margin-top: -3px;
          "
        />
        <img
          class="picA2"
          src="../../assets/new/czsc_a2.png"
          alt=""
          style="
            vertical-align: middle;
            width: 20px;
            height: 20px;
            margin-top: -3px;
          "
        /> -->
        帮助中心
      </span>

      <img
        class="avatar"
        src="../../assets/avatar.png"
        alt=""
        style="border-radius: 50%; margin-right: 10px"
      />
      <div class="loginBox">
        <el-dropdown @command="handleCommand">
          <div class="el-dropdown-link userNameClass">
            <div>
              <div>{{ username }}</div>
              <div>{{ roleName }}</div>
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">修改密码</el-dropdown-item>
            <el-dropdown-item command="b">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- <span @click="spanClick">{{ username }}</span>
      <span @click="exit">退出</span> -->
    </div>


    

    <el-dialog :visible.sync="noticePopupShow" width="415px">
      <div class="noticeBox" v-if="noticeData.length > 0">
        <div v-if="noticeData[noticeIndex].type_name" class="type_name">{{ noticeData[noticeIndex].type_name }}</div>
        <div v-if="noticeData[noticeIndex].title" class="title">{{ noticeData[noticeIndex].title }}</div> 
        <div class="btn" @click="noticeBtn(noticeData[noticeIndex].id)">点击查看</div>
      </div>
    </el-dialog>

    
    <el-dialog :visible.sync="RechargeShow" width="400px">
      <div class="RechargeBox">
        <div class="rightH2Top">
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a5.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            技术对接和充值:
            {{ contacts }}
          </div>
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a4.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            联系方式：
            {{ contacts_moblie }}
          </div>
        </div>
        <div class="rightH2Bottom">
          <div class="rightH2b">
            <img
              class="img"
              :src="quickresponse"
              alt=""
              style="width: 100%; height: 100%; margin-bottom: 7px"
            />
            <div>微信咨询 扫码联系</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import goodsApi from "@/api/goods.js";
import userApi from "@/api/common.js";
import QrCode4 from "@/components/QrCode4.vue";
import { copyToClip } from "@/utils/index.js";
import Bus from "@/utils/bus.js";
export default {
  name: "Header",
  components: { QrCode4 },
  data() {
    return {
      groupName: "",
      shareLinkData: "https://docs.qq.com/doc/DT01TRnJpdVZLT2Ns",
      isCollapse: true,
      set_active_name: "",
      groupLogo: "",
      domain: "",
      un_read_total: 0,
      noticePopupShow: false,
      noticeData: [],
      noticeIndex: 0,
      xcx_img:"", 
      invite_code:"", 
      is_open_xcx:"",
      RechargeShow: false,
      contacts: "",
      contacts_moblie: "",
      quickresponse: "", 
      codeUrl:"",
      group_id:"",
      code: ""
    };
  },
  computed: {
    username() {
      return this.$store.state.user.userInfo.realname || "";
    },
    roleName() {
      return this.$store.state.user.userInfo.role_name || "";
    },
    logo() {
      return "../../assets/logo.png";
      // return this.$store.state.user.userInfo?this.$store.state.user.userInfo.group.logo:require('../../assets/logo.png')
    },
  },
  watch: {
    noticePopupShow(newVal, oldVal) {
      console.log("newVal---", newVal, this.noticeIndex, this.noticeLength, this.noticeIndex + 1 < this.noticeLength); 
      if (!newVal) { 
        if(this.noticeIndex + 1 < this.noticeLength && this.noticeData[this.noticeIndex].type_name){
          setTimeout(() => {
            this.noticeIndex++
            this.noticePopupShow = true
            this.resetExamType(this.noticeData[this.noticeIndex].id)
          }, 500);
        }
      }
    },
  },   
  created() {
    if(localStorage.getItem("un_read_total")){
      console.log("un_read_total---", localStorage.getItem("un_read_total"))

    }  
    if(localStorage.getItem("noticeShow")){ 
      this.getTobNoticePopupList()
    }
    // if(localStorage.getItem("invite_code")){
    //   const invite_code = localStorage.getItem("invite_code")
    //   this.invite_code = invite_code.toString()
    // }

    if(localStorage.getItem("contacts")){
      this.contacts = localStorage.getItem("contacts") 
    }
    if(localStorage.getItem("contacts_moblie")){
      this.contacts_moblie = localStorage.getItem("contacts_moblie") 
    }
    if(localStorage.getItem("quickresponse")){
      this.quickresponse = localStorage.getItem("quickresponse") 
    } 
     
    console.log("userInfo", this.$store.state.user.userInfo);
    this.getNoticeList()
    this.getScreenWidth()
    this.homeList()
    this.getMe()
    let _name = this.$store.state.user.userInfo.group.name;
    this.groupName = _name;
    this.groupLogo = this.$store.state.user.userInfo.group.logo;
    this.admin_realname = this.$store.state.user.userInfo.group.admin_realname;
    this.domain = this.$store.state.user.userInfo.group.domain;
    Bus.$on("set_active_name", (data) => {
      // console.log("222---", data);
      this.set_active_name = data;
    });
  },
  methods: {   
    async getMe() {
      const res = await commonApi.tobMe()
      if (res.code === 200) { 
        this.invite_code = res.data.group.code
        this.group_id = res.data.group.id 

        setTimeout(() => {
          this.getActivityXcxCode() 
        }, 1000)
      }
    },
    getWxcodeEnvVersion(){
      if (process.env.NODE_ENV == "production") {
          return "release";
      } else {
          return "trial";
      }
    },
    getActivityXcxCode(){ 
      var XcxData = {
        scene: this.invite_code,
        page: "pages/examIndex",
        width: "280",
        check_path: false,
        is_hyaline: true,
        env_version: this.getWxcodeEnvVersion()
      }
      commonApi.getActivityXcxCode({ 
        data:  JSON.stringify(XcxData), 
        type: '3', 
        invite_code: this.invite_code,
        is_oss_url: 1,
        group_id: this.group_id
      }).then((res) => {
        console.log("header", res.data.oss_url); 
        this.codeUrl = res.data.oss_url 
      });
    },
 
    RechargeData(e){
      console.log("RechargeData", e)
      this.RechargeShow = e
    },
    async homeList() {
      const res = await commonApi.homeData({ app_keys: '' });
      if (res.code == 200) { 
        this.xcx_img = res.data.xcx_img  
        this.is_open_xcx = res.data.is_open_xcx.toString() 
        localStorage.setItem("xcx_img", this.xcx_img) 
        localStorage.setItem("is_open_xcx", this.is_open_xcx)  
        localStorage.setItem("show_student_active_status", res.data.show_student_active_status)  
        console.log("homeData---", res.data)
      }
    },  
    noticeBtn(e){
      this.noticePopupShow = false
      this.$router.replace({
        path: "/noticeDetail",
        query: {
          id: e,
        },
      });
      window.location.reload()
    },
    resetExamType(e){
      goodsApi.resetExamType({notice_id:e}).then((res) => {
        this.getNoticeList()
      })
    },
    getTobNoticePopupList(){ 
      localStorage.setItem("noticeShow", false) 
      goodsApi.getTobNoticePopupList().then((res) => {
        if (res.code === 200) {
          console.log("getTobNoticePopupList", res.data.list)
          if(res.data.list&&res.data.list.length>0){ 
            this.noticeData = res.data.list 
            this.noticePopupShow = true
            this.noticeLength = res.data.list.length
            this.noticeIndex = 0
            
            this.resetExamType(this.noticeData[this.noticeIndex].id)
          }
        }
      });
    }, 
    getNoticeList(){
      this.un_read_total = 0
      userApi.getNoticeList()
        .then((res) => {
          if (res.code == 200) {
            console.log("getNoticeList---",res.data.un_read_total) 
            localStorage.setItem("un_read_total", res.data.un_read_total) 
            this.un_read_total = res.data.un_read_total
 
          }
        }) 
    }, 
    bktxu(){
      window.open(this.domain, "_blank");
    },
    webSkip() {
      // 网站跳转
      window.open(this.domain, "_blank");
    },
    webCopy() {
      // 网站复制
      copyToClip(`${this.domain}`);
      this.$message.success("复制成功！");
    },
    handleCommand(e) {
      console.log("handleCommand", e);
      if (e == "a") {
        this.$router.push({ path: "/personalSettings" });
      } else if (e == "b") {
        this.exit();
      }
    },
    getScreenWidth() {
      var screenWidth = document.body.clientWidth;
      if (screenWidth < 979) {
        this.isCollapse = true;
        this.closeWidth = "0 !important";
      } else {
        this.isCollapse = false;
        this.closeWidth = "64px !important";
      }
    },
    userFeedback() {
      // 用户反馈
      this.$router.push({ path: "/noticeList" });
    },
    tobExperienceCard(){
      this.$router.push({ path: "/appDownload" });
    },
    shrinkClick() {
      this.isCollapse = !this.isCollapse;
      Bus.$emit("getListInfo", this.isCollapse);
    },
    operationManual() {
      // 操作手册
      // window.open(this.shareLinkData, "_blank");
      this.$router.push({ path: "/operateVideo" });
    },
    spanClick() {
      this.$router.push({ path: "/personalSettings" });
    },
    async exit() {
      this.$confirm(`确定退出登录？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        center: true,
      })
        .then(async () => {
          localStorage.clear();
          await this.$store.dispatch("user/logout");
          this.$router.push("/login");
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  color: #191b27;
  text-align: center;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  height: 60px;
  & > div {
    display: flex;
    align-items: center;
    img {
      border-radius: 10px;
    }
  }
  .left {
    font-size: 16px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }
  }
  .right {
    font-size: 14px;
    line-height: 120%;
    .picItem {
      font-size: 13px;
      color: #465069;
    }
    .title {
      color: #191b27;
      font-size: 16px;
    }
    img {
      width: 30px;
      height: 30px;
    }
    span {
      display: inline-block;
      cursor: pointer;
      color: #465069;
      margin-left: 15px;
    }
  }
}
/deep/ .shrink {
  // width: 16px;
  // height: 16px;
  vertical-align: middle;
  margin-left: 10px;
  margin-bottom: -1px;
  display: block;
}
.picItem {
  position: relative;
  .picA1 {
    display: inline-block !important;
  }
  .picA2 {
    display: none !important;
  } 
  .tzzx{ 
    position: absolute;
    right: -10px;
    top: -10px;
    padding: 0 5px;
    border-radius: 15px;
    background: red;
    color: #fff;
  }
}
.picItem:hover {
  color: #7861ff !important;

  .picA1 {
    display: none !important;
  }
  .picA2 {
    display: inline-block !important;
  }
}
/deep/ .userNameClass {
  color: #191b27 !important;
  font-size: 14px;
  display: flex;
  align-items: center;
}

/deep/ .dhzx {
  display: none;
}

@media (max-width: 979px) {
  /deep/.shrink {
    display: flex !important;
    align-items: center !important;
    border: 1px solid #ddd !important;
    padding: 0 10px !important;
    height: 28px !important;
    border-radius: 6px !important;
    margin-left: 0 !important;
  }

  /deep/.rightCloss {
    display: none !important;
  }
  /deep/ .dhzx {
    display: block !important;
  }
  /deep/ .loginBox {
    display: inline-block !important;
  }
  /deep/ .userNameClass {
    color: #191b27 !important;
    font-size: 14px;
  }

  /deep/.loginBox .el-dropdown {
    color: #191b27 !important;
  }

  

  .groupName{
    line-height: 100%;
  }
}

/deep/.bktxu{
    display: inline-block;
    margin-right: 10px;
    .bktxu_h1{
      padding: 3px 20px;
      border: 1px solid;
      border-radius: 25px;
      cursor: pointer;
      margin-bottom: 3px;
    }
}
/deep/.xcxtc{
    display: inline-block;
    margin-right: 10px; 
}
.noticeBox{
  .type_name{
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }
  .title{
    text-align: center;
    font-size: 16px;
    color: #000;
    padding-top: 10px;
  }
  .btn{
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    width: 120px;
    line-height: 40px;
    border-radius: 20px;
    border: 1px solid #ddd;
    cursor: pointer;
  }

  /deep/.xcxImg{
    .img{
      display: block;
      width: 200px;
      height: 200px;
    }
  }
}
.RechargeBox {
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 40px;
  .rightH2Top {
    // padding: 0 0 0 50px;
    // padding-bottom: 25px;
    // border-bottom: 1px solid #ddd;
    .rightH2a {
      line-height: 180%;
      font-size: 18px;
      color: #465069;
    }
  }
  .rightH2Bottom {
    // padding-top: 10px;
    margin-top: 25px;
    .rightH2b {
      width: 132px;
      padding: 14px 13px;
      line-height: 140%;
      padding-bottom: 10px;
      text-align: center;
      background: #f7f8fb;
      border-radius: 8px;
      display: block;
      margin: 0 auto;
      font-size: 15px;
      color: #6d7181;
    }
  }
}

/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) {
  .right{
    .bktxu{
      display: none;

    }
    .xcxtc{
      display: none; 
    }
    .avatar{
      display: none;  
    }
  }  
}
</style>
